import { useMemo } from 'react';

import { InventoryType, ISiloInfo, SiloDimensions, SiloShape } from '@scaleaq/sitecontrol-lib';

type Silo = {
  dimensions: SiloDimensions;
  siloShape: SiloShape;
  density: number;
  alarmLevels: {
    low: number;
    high: number;
  };
  content: string | undefined;
  sensorRange: {
    min: number;
    max: number;
  };
  level: {
    height: number;
    volume: number;
  };
  siloIndex: number;
  inventoryType: InventoryType;
  inventoryId: string | undefined;
  controller: string;
  host: string;
};

export const useSiloShape = (siloInfo: ISiloInfo) => {
  const {
    density,
    highLevelAlarm,
    id,
    levelHeightOutput,
    levelVolumeOutput,
    lowLevelAlarm,
    maxSensorRange,
    minSensorRange,
    siloContent,
    siloIndex,
    dimensions,
    siloShape,
    type,
    fields: { controller, host },
  } = siloInfo;

  const silo = useMemo<Silo | null>(() => {
    if (!siloInfo) return null;
    return {
      siloShape,
      dimensions,
      density,
      alarmLevels: {
        low: lowLevelAlarm,
        high: highLevelAlarm,
      },
      content: siloContent,
      sensorRange: {
        min: minSensorRange,
        max: maxSensorRange,
      },
      level: {
        height: levelHeightOutput,
        volume: levelVolumeOutput,
      },
      inventoryType: type,
      siloIndex,
      inventoryId: id,
      controller,
      host,
    };
  }, [
    controller,
    density,
    dimensions,
    highLevelAlarm,
    host,
    id,
    levelHeightOutput,
    levelVolumeOutput,
    lowLevelAlarm,
    maxSensorRange,
    minSensorRange,
    siloContent,
    siloIndex,
    siloInfo,
    siloShape,
    type,
  ]);

  return { ...silo };
};
